import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';

export const projects = [
    {
        title: "Critique platform",
        subtitle: "Android, SQlite and Firebase",
        description:
            "Critique API allows clients to write feedback messages to the API and receive such feedback messages through our API on their daily activity",
        image: "./project-1.jpg",
        link: "https://github.com/sercant/critique",
    },
    {
        title: "Augmented nature",
        subtitle: "React, Amplify and Computer vision",
        description:
            "Online gamified platform to encourage and help students going into the wilderness for collecting and identifying different varieties of plant types",
        image: "./project-2.jpg",
        link: "https://docs.google.com/presentation/d/1QQcqOya7ia2uAWVYxX6RvCPxZRYICDTbsWCmLvL9810/edit?usp=sharing",
    },
    {
        title: "Cancer psychosocial project",
        subtitle: "Machine learning, React and Firebase",
        description:
            "Find out how psychosocial factors  presented in medical records and social platforms using natural language processing",
        image: "./project-3.jpg",
        link: "https://github.com/moamenibrahim/cancer-psychosocial-project",
    },
    {
        title: "Vulkan ray-tracing renderer",
        subtitle: "Ray tracing, Vulkan and C++",
        description:
            "Ray-tracing renderer using Vulkan in C++ to render 3D scenes with realistic lighting, shadows, and reflections",
        image: "./project-4.jpg",
        link: "https://github.com/moamenibrahim/vkRenderProto",
    },
];

export const skills = [
    "Python", "Golang", "Java", "Javascript", "Typescript", "C#", "C++", "Matlab"
];

export const experience = [
    {
        time: "Dec 2022-present",
        icon: (<WorkIcon color="primary" />),
        position: "MACHINE LEARNING ENGINEER",
        url: "https://solita.fi",
        company: "Solita Oy",
        details: "Consultative role, helping customers to understand their data needs and solve ML challenges utilizing modern tools and MLOps",
    },
    {
        time: "Oct 2019-Dec 2022",
        icon: (<WorkIcon color="primary" />),
        position: "AI & MACHINE LEARNING ENGINEER",
        url: "https://www.nokia.com/networks/",
        company: "Nokia Solutions and Networks",
        details: "Smart automation softwares including 3D handling and rendering pipelines, machine learning applications, microservices and multi-platform applications",
    },
    {
        time: "Feb-July 2019",
        icon: (<WorkIcon color="primary" />),
        position: "SOFTWARE ENGINEER",
        url: "https://www.qt.io/company",
        company: "The Qt company",
        details: "Development of Qt continuous integration system (Coin) used to build and test software releases of Qt cross-platform C++ framework",
    },
    {
        time: "2018-2019",
        icon: (<WorkIcon color="primary" />),
        position: "RESEARCH & TEACHING ASSISTANT",
        url: "https://ubicomp.oulu.fi/",
        company: "University of Oulu, Finland",
        details: "Text mining, text analysis and natural language processing to reveal effects of psychosocial factors in cancer in the ESKO database and Social Media",
    },
    {
        time: "2017-2019",
        icon: (<SchoolIcon color="primary" />),
        position: "MASTERS OF COMPUTER SCIENCE AND ENGINEERING",
        url: "https://ubicomp.oulu.fi/",
        company: "University of Oulu, Finland",
        details: "Human Computer interaction, Artificial intelligence and Natural language processing",
    },
    {
        time: "2012-2017",
        icon: (<SchoolIcon color="primary" />),
        position: "BACHELOR OF COMMUNICATION AND ELECTRONICS ENGINEERING",
        url: "https://eng.alexu.edu.eg/index.php/en/",
        company: "Alexandria University, Egypt",
        details: "Electronics engineering, robotics, programming and embedded systems",
    }
];
